import { v4 as uuidv4 } from 'uuid';

export function getRowId(): string {
  return uuidv4();
}
